import {
  IPlatformImplementationStep,
  IPlatformImplementationStepPayload,
  IPlatformResourceResponse,
  IPlatformResourcesResponse
} from 'types/platformResources';
import request from './index';

export const getPlatformImplementationSteps = () =>
  request<IPlatformResourcesResponse<IPlatformImplementationStep>>({
    options: { url: '/platform/resources/implementation_steps', method: 'get' }
  });

export const createPlatformImplementationStep = (data: IPlatformImplementationStepPayload) =>
  request<IPlatformResourceResponse<IPlatformImplementationStep>>({
    options: {
      url: '/platform/resources/implementation_steps',
      method: 'post',
      data
    }
  });

export const editPlatformImplementationStep = (
  id: number,
  data: IPlatformImplementationStepPayload
) =>
  request<IPlatformResourceResponse<IPlatformImplementationStep>>({
    options: {
      url: `/platform/resources/implementation_steps/${id}`,
      method: 'patch',
      data
    }
  });

export const deletePlatformImplementationStep = (id: number) =>
  request<Record<string, never>>({
    options: {
      url: `/platform/resources/implementation_steps/${id}`,
      method: 'delete'
    }
  });
